module.exports = __webpack_public_path__ + "static/gift2.98063bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/other/gift2.png
// module id = 193
// module chunks = 35783957827783 246384609461072